package com.projectas.app.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.projectas.app.style.TextSelectionStyle
import com.projectas.app.util.BackgroundGradient
import com.projectas.app.util.Constants.LATO_REGULAR
import com.projectas.app.util.Constants.SUPPORT_EMAIL
import com.projectas.app.util.Theme
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
@Page
fun ContactPage() {
    val breakpoint = rememberBreakpoint()
    val largeBreakpoint = remember(breakpoint) {
        breakpoint > Breakpoint.LG
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundImage(BackgroundGradient),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    leftRight = if (breakpoint > Breakpoint.LG) 120.px
                    else if (breakpoint == Breakpoint.LG) 100.px
                    else if (breakpoint > Breakpoint.MD) 70.px
                    else if (breakpoint == Breakpoint.MD) 50.px
                    else 40.px
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            P(
                attrs = TextSelectionStyle.toModifier()
                    .fillMaxWidth()
                    .maxWidth(if (largeBreakpoint) 800.px else 380.px)
                    .color(Theme.Text.rgb)
                    .fontFamily(LATO_REGULAR)
                    .fontSize(if (largeBreakpoint) 1.5.cssRem else 1.2.cssRem)
                    .lineHeight(1.8)
                    .textAlign(TextAlign.Center)
                    .toAttrs()
            ) {
                Text("Need help with ")
                SpanText(
                    modifier = Modifier.color(Theme.Primary.rgb),
                    text = "Projectas")
                Text("? Contact us at: $SUPPORT_EMAIL")
            }
        }
    }
}